import React from "react"
import autobind from "class-autobind"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import TimelineTableRightSideHorizontalRow from "./TimelineTableRightSideHorizontalRow"
import { IClientDocument, IJobDocument, IScheduleDailyTimelineData, ISimpleTime } from "../../../models"
import strings from "../../../localization/strings"
import EditIcon from "material-ui/svg-icons/image/edit"
import DeleteIcon from "material-ui/svg-icons/action/delete"
import AddShiftTemplateDialog from "../add_shift_template/AddShiftTemplateDialog"
import { grey100 } from "material-ui/styles/colors"
import AppStateStore from "../../../stores/AppStateStore"
import _ from "lodash"
interface IProps {
  items: any[]
  timelineData: IScheduleDailyTimelineData[][]
  selectedItems: any[]
  widthPerHour: number
  timelineBarHourLength: number
  coordinateTime: ISimpleTime
  width: number
  hoveredRowNumber: number
  readonly: boolean
  dragDropRowId: string
  referenceFieldNameForEdit?: string
  referenceFieldNameToIdentifyPatternTemplate?: string
  showRowHover: boolean
  handleUpdate(row: any): void
  handleOnRowHover(rowNumber: number): void
  handleOnRowHoverExit(): void
  timelineItemRenderElement(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): JSX.Element
  handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): void
  checkValidateNewTimeline?(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): boolean
  handleDeleteTimelineItem?(rowNumber: number, orderNumber: number): void
  handleUpdateTimelineItem?(item: any, rowNumber: number, orderNumber: number)

  // allow to edit by Tab
  allowQuickEditTime?: boolean

  scheduleJob: IJobDocument
  scheduleClient: IClientDocument
}
interface IState {
  showPopup: boolean
  popupX: number
  popupY: number
  timelineData: IScheduleDailyTimelineData[][]
  editItem: any
  quickEditTimeRowNumber: number
  quickEditTimeOrderNumber: number
}

export default class TimelineTableRightSide extends React.Component<IProps, IState> {
  private popupTimelineItemRowNumber
  private popupTimelineItemOrderNumber
  private TimelineTableRightSideHorizontalRow = []
  constructor(props) {
    super(props)
    this.state = {
      showPopup: false,
      popupX: null,
      popupY: null,
      timelineData: props.timelineData,
      editItem: null,
      quickEditTimeRowNumber: null,
      quickEditTimeOrderNumber: null,
    }
    autobind(this)
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickDocument)
    window.addEventListener("keyup", this.handleKeyPress)
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.timelineData) !== JSON.stringify(nextProps.timelineData)) {
      this.setState({ timelineData: nextProps.timelineData })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickDocument)
    window.addEventListener("keyup", this.handleKeyPress)
  }

  handleClickDocument() {
    this.setState({ showPopup: false })
  }

  handleKeyPress(e) {
    if (this.state.quickEditTimeRowNumber !== null && e.keyCode === 13) {
      this.handleSaveQuickEditTime()
      this.handleMoveToNextQuickEditTimeItem()
    }
  }

  handleSaveQuickEditTime() {
    const quickEditTimeElem = this.TimelineTableRightSideHorizontalRow[this.state.quickEditTimeRowNumber].TimelineItem[this.state.quickEditTimeOrderNumber].TimelineItemQuickEditTime
    const originalQuickEditTimeItem = this.state.timelineData[this.state.quickEditTimeRowNumber][this.state.quickEditTimeOrderNumber]

    if (_.isEqual(quickEditTimeElem.state.startTime, originalQuickEditTimeItem.StartTime) && _.isEqual(quickEditTimeElem.state.endTime, originalQuickEditTimeItem.EndTime)) return

    const editTimelineItem = {
      StartTime: quickEditTimeElem.state.startTime,
      EndTime: quickEditTimeElem.state.endTime,
      Breaks: originalQuickEditTimeItem.Breaks
    }

    const isValidNewTimelineItem = this.props.checkValidateNewTimeline ?
      this.props.checkValidateNewTimeline(editTimelineItem, this.state.quickEditTimeRowNumber, this.state.quickEditTimeOrderNumber) : true
    isValidNewTimelineItem &&
      this.props.handleUpdateTimelineData(editTimelineItem, this.state.quickEditTimeRowNumber, this.state.quickEditTimeOrderNumber)
  }

  handleMoveToNextQuickEditTimeItem() {
    const quickEditTimeRow = this.state.timelineData[this.state.quickEditTimeRowNumber]
    const moveToNextRow = quickEditTimeRow.length - 1 === this.state.quickEditTimeOrderNumber
    if (moveToNextRow) {
      const initQuickEditTime = this.state.timelineData.length - 1 === this.state.quickEditTimeRowNumber
      this.setState({ quickEditTimeRowNumber: initQuickEditTime ? null : this.state.quickEditTimeRowNumber + 1, quickEditTimeOrderNumber: initQuickEditTime ? null : 0 })
    }
    else {
      this.setState({ quickEditTimeOrderNumber: this.state.quickEditTimeOrderNumber + 1 })
    }
  }

  handleShowPopup(popupX, popupY, rowNumber, orderNumber) {
    this.popupTimelineItemRowNumber = rowNumber
    this.popupTimelineItemOrderNumber = orderNumber
    this.setState({ showPopup: true, popupX, popupY })
  }

  handleDeleteTimelineItem() {
    const timelineData = this.state.timelineData
    timelineData[this.popupTimelineItemRowNumber].splice(this.popupTimelineItemOrderNumber, 1)
    this.props.handleDeleteTimelineItem && this.props.handleDeleteTimelineItem(this.popupTimelineItemRowNumber, this.popupTimelineItemOrderNumber)
    this.setState({ timelineData })
  }

  handleUpdateItem(item) {
    this.setState({ editItem: null })
    const isValidate = this.props.checkValidateNewTimeline ?
      this.props.checkValidateNewTimeline({ StartTime: item.StartTime, EndTime: item.EndTime, Breaks: item.Breaks }, this.popupTimelineItemRowNumber, this.popupTimelineItemOrderNumber) : true
    isValidate && this.props.handleUpdateTimelineItem &&
      this.props.handleUpdateTimelineItem(item, this.popupTimelineItemRowNumber, this.popupTimelineItemOrderNumber)
  }

  getTimeLabel(time): string {
    let timeLabel
    if (time === 0 || time === 24) {
      timeLabel = "12a"
    }
    else if (time === 12) {
      timeLabel = "12p"
    }
    else if (time % 24 < 12) {
      timeLabel = time % 12 + "a"
    }
    else {
      timeLabel = time % 12 + "p"
    }
    return timeLabel
  }

  render() {
    const timeArray: number[] = []
    for (let i = 0; i < this.props.timelineBarHourLength; i++) {
      timeArray.push(i)
    }
    return (
      <div>
        <Table
          style={{ overflow: "hidden" }}
          onRowHover={this.props.handleOnRowHover}
          onRowHoverExit={this.props.handleOnRowHoverExit}
        >
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow style={{ backgroundColor: grey100, borderTop: "1px solid rgb(224, 224, 224)", borderLeft: "1px solid rgb(224, 224, 224)", borderRight: "1px solid rgb(224, 224, 224)" }}>
              <TableHeaderColumn
                style={{ textAlign: "center", paddingLeft: 0, paddingRight: 0, position: "relative" }}
              >
                {timeArray.map(time =>
                  <div
                    key={time}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: this.props.widthPerHour * time,
                      width: this.props.widthPerHour - 2,
                      height: 39,
                      borderRight: "1px solid rgb(224, 224, 224)",
                      paddingTop: 20
                    }}
                  >
                    {this.getTimeLabel(time)}
                  </div>
                )}
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            showRowHover={this.props.showRowHover}
            deselectOnClickaway={false}
            displayRowCheckbox={false}
            style={{ borderBottom: "1px solid rgb(224, 224, 224)" }}
          >
            {this.state.timelineData.map((dailyData, index) =>
              <TableRow
                id={`right_${this.props.items[index] && this.props.items[index].Id}`}
                key={index}
                style={{
                  visibility: this.props.dragDropRowId && this.props.dragDropRowId === this.props.items[index].Id ? "hidden" : "visible",
                  borderLeft: "1px solid rgb(224, 224, 224)",
                  borderRight: "1px solid rgb(224, 224, 224)"
                }}
                hovered={this.props.hoveredRowNumber === index}
              >
                <TableRowColumn style={{ position: "relative" }}>
                  {timeArray.map(time =>
                    <div
                      key={time}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: this.props.widthPerHour * time,
                        width: this.props.widthPerHour - 2,
                        height: 50,
                        borderRight: "1px solid rgb(224, 224, 224)"
                      }}
                    />
                  )}
                  <TimelineTableRightSideHorizontalRow
                    ref={i => this.TimelineTableRightSideHorizontalRow[index] = i}
                    rowNumber={index}
                    handleUpdateTimelineData={this.props.handleUpdateTimelineData}
                    width={this.props.width}
                    widthPerHour={this.props.widthPerHour}
                    timelineBarHourLength={this.props.timelineBarHourLength}
                    coordinateTime={this.props.coordinateTime}
                    item={this.props.items[index]}
                    timelineItemRenderElement={this.props.timelineItemRenderElement}
                    dailyData={dailyData}
                    selected={this.props.selectedItems.indexOf(this.props.items[index]) > -1}
                    handleUpdate={this.props.handleUpdate}
                    checkValidateNewTimeline={this.props.checkValidateNewTimeline}
                    handleShowPopup={this.handleShowPopup}
                    handleHidePopup={() => this.setState({ showPopup: false })}
                    readonly={this.props.readonly}
                    allowQuickEditTime={this.props.allowQuickEditTime}
                    quickEditTimeRowNumber={this.state.quickEditTimeRowNumber}
                    quickEditTimeOrderNumber={this.state.quickEditTimeOrderNumber}
                    handleSelectQuickEditTimeRow={(quickEditTimeRowNumber, quickEditTimeOrderNumber) => this.props.allowQuickEditTime && this.setState({ quickEditTimeRowNumber, quickEditTimeOrderNumber })}
                  />
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {this.state.showPopup &&
          <div
            style={{
              position: "fixed", top: this.state.popupY, left: this.state.popupX, backgroundColor: "white", color: "rgba(97, 97, 97, 0.8)",
              boxShadow: "1px 1px 5px rgba(224, 224, 224, 0.5)", width: 110, zIndex: 1000, cursor: "default"
            }}
          >
            <div
              style={{ borderBottom: "1px solid rgb(224, 224, 224)", paddingTop: 10, paddingBottom: 7, display: "flex" }}
              onMouseDown={(e) => {
                e.stopPropagation()
                this.setState({
                  editItem: this.props.referenceFieldNameToIdentifyPatternTemplate ?
                    this.props.items[this.popupTimelineItemRowNumber][this.props.referenceFieldNameToIdentifyPatternTemplate].ShiftTemplates[this.popupTimelineItemOrderNumber] :
                    this.props.referenceFieldNameForEdit ?
                      this.props.items[this.popupTimelineItemRowNumber][this.props.referenceFieldNameForEdit][this.popupTimelineItemOrderNumber] :
                      this.props.items[this.popupTimelineItemRowNumber].ShiftTemplates[this.popupTimelineItemOrderNumber]
                })
              }}
            >
              <div><EditIcon style={{ height: 17, width: 17, marginLeft: 10, marginRight: 10 }} /></div>
              <div>{strings.Edit}</div>
            </div>
            {!this.state.timelineData[this.popupTimelineItemRowNumber][this.popupTimelineItemOrderNumber].Used &&
              <div
                style={{ paddingTop: 10, paddingBottom: 7, display: "flex" }}
                onMouseDown={(e) => {
                  e.stopPropagation()
                  AppStateStore.setConfirmDialogContent({
                    content: strings.Are_you_sure_you_want_to_remove_this_shift_template,
                    confirm: () => this.handleDeleteTimelineItem()
                  })
                }}
              >
                <div><DeleteIcon style={{ height: 17, width: 17, marginLeft: 10, marginRight: 10 }} /></div>
                <div>{strings.Remove}</div>
              </div>
            }
          </div>
        }
        {this.state.editItem &&
          <AddShiftTemplateDialog
            editShiftTemplate={this.state.editItem}
            handleClose={() => this.setState({ editItem: null })}
            handleUpdate={this.handleUpdateItem}
            scheduleJob={this.props.scheduleJob}
            scheduleClient={this.props.scheduleClient}
          />
        }
      </div >
    )
  }
}